export const CAPTCHA_SITE_KEY = 'ysc1_53mKcbjvtClFuWM90nBOqjubqfduv9M36KRBQy76a9172732';
